<template>
  <v-dialog v-model="dialog" content-class="v-dialog--custom"
    :fullscreen="$vuetify.breakpoint.xsOnly">
    <v-card>
      <v-card-title class="headline">Delete Time Clock Confirmation</v-card-title>
      <v-card-text>
        <v-container>
          <alert-message />
          <div class="d-flex flex-column">
            <span>Are you sure want to delete this running time clock entry?</span>
            <br>
            <span
              v-if="item && item.name"
              class="d-flex"
              style="gap:1rem;"
            >
              <h4>Job:</h4>
              {{ item.name }} {{ item.code ? ` [${item.code}]` : '' }}
            </span>
            <span
              v-if="
                runningTimeClock && 
                (runningTimeClock.employeeFirstName || runningTimeClock.employeeLastName)
              "
              class="d-flex"
              style="gap:1rem;"
            >
              <h4>User:</h4>
              {{ runningTimeClock.employeeFirstName + ' ' + runningTimeClock.employeeLastName }}
            </span>
            <span
              v-if="runningTimeClock && runningTimeClock.startTime"
              class="d-flex"
              style="gap:1rem;"
            >
              <h4>Clock-in:</h4>
              {{ momentLocal(runningTimeClock.startTime).format('yyyy-MM-DD hh:mma') }}
            </span>
            
          </div>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="closeCancel">Cancel</v-btn>
        <v-btn class="error" text @click="deleteItemConfirm" :loading="loading"
          >Delete
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import AlertMessage from 'src/components/AlertMessage.vue';
import formatterMixin from "@/mixins/formatterMixin";

export default {
  mixins: [formatterMixin],
  components: { AlertMessage },
  props: {
    item: Object,
    show: [Boolean, String],
  },
  data() {
    return {
      dialog: false,
      loading: false,
    };
  },
  computed: {
    ...mapGetters("account", ["hasAccess"]),
    ...mapState({
      account: (state) => state.account.data,
      status: (state) => state.timeclockEntry.status,
      alert: (state) => state.alert,
      runningTimeClock: (state) => state.task.runningTimeClock,
    }),
  },
  watch: {
    show(n, o) {
      this.$store.dispatch('alert/clear');
      if (n && !o) {
        this.dialog = true;
      }
    },

    item: {
      async handler(n) {
        if(JSON.stringify(n) && n?.id) {
          await this.getRunningClockByTaskId(n.id);
        }
      },
      deep: true,
    }
  },
  methods: {
    ...mapActions("timeclockEntry", ["delete"]),
    ...mapActions({
      getRunningClockByTaskId: "task/getRunningClockByTaskId"
    }),   
    closeCancel() {
      this.dialog = false;
      this.$emit("onClosed");
    },
    async deleteItemConfirm() {
      this.loading = true;
      const payload = {
        ...this.runningTimeClock,
        id: this.runningTimeClock.id || this.runningTimeClock.Id
      }
      await this.delete(payload);
      if (!this.status?.error) {
        this.closeCancel();
        this.$emit("onSucceded");
      }
      this.loading = false;
    },
  },
};
</script>